import type { CardEntityId } from '@terros/common'
import type { QueryKey } from '@tanstack/react-query'

export const cardKey = (entityId: CardEntityId | undefined): QueryKey => ['card', entityId]
